import * as React from "react";
const SVGComponent = (props) => (
  <svg
    width={21}
    height={21}
    viewBox="0 0 21 21"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M6 10.2041C6 11.3041 6.2 12.3041 6.6 13.3041C6.7 13.7041 7 13.9041 7.4 14.0041H7.5C7.8 14.0041 8.1 13.9041 8.3 13.6041C9.4 12.1041 11.1 10.9041 13 10.3041V11.0041C13 11.4041 13.2 11.8041 13.6 11.9041C14 12.1041 14.4 12.0041 14.7 11.7041L19.7 6.70405C20.1 6.30405 20.1 5.70405 19.7 5.30405L14.7 0.304052C14.4 0.00405186 14 -0.0959482 13.6 0.104052C13.2 0.204052 13 0.604052 13 1.00405V1.90405C9 2.60405 6 6.10405 6 10.2041ZM14.1 3.80405C14.4 3.80405 14.7 3.60405 14.9 3.30405L17.6 6.00405L15 8.60405C14.9 8.40405 14.8 8.30405 14.7 8.20405C14.4 8.00405 14.1 8.00405 13.8 8.00405C11.7 8.40405 9.6 9.40405 8 10.9041C8 10.7041 8 10.4041 8 10.2041C8 6.80405 10.7 4.00405 14.1 3.80405Z"
      fill="white"
    />
    <path
      d="M19 11.0039C18.4 11.0039 18 11.4039 18 12.0039V16.1039C18 17.1039 17.2 18.0039 16.1 18.0039H3.9C2.9 18.0039 2 17.2039 2 16.1039V3.90391C2 2.80391 2.8 2.00391 3.9 2.00391H8C8.6 2.00391 9 1.60391 9 1.00391C9 0.403906 8.6 0.00390625 8 0.00390625H3.9C1.7 0.00390625 0 1.70391 0 3.90391V16.2039C0 18.3039 1.7 20.0039 3.9 20.0039H16.2C18.3 20.0039 20.1 18.3039 20.1 16.1039V12.0039C20 11.4039 19.6 11.0039 19 11.0039Z"
      fill="white"
    />
  </svg>
);
export default SVGComponent;
